/**
 * UPAM-feature "ReviewLineTexts": de eigen lijnteksten van de Rave I'Ching in de app
 * goedkeuren of herschrijven (vinkje en potlood bij elke eigen tekst, plus het
 * reviewoverzicht). Zelfde GUID als `AppConstants.Features.ReviewLineTextsFeatureId`
 * in de backend; declaratie op de chart-pagina (hd.pages.module.ts), toekenning in
 * UPAM per gebruikersgroep. Zonder feature ziet de gebruiker de teksten gewoon (met
 * de herschreven versies), maar zonder reviewknoppen.
 */
export const REVIEW_LINE_TEXTS_FEATURE_ID = 'ed17a1e5-0000-4000-8000-0000ed17a1e5';

/** De drie eigen teksten per lijn; sleutelnamen zoals in de scope `gate-lines-own`. */
export type HdLineTextField = 'description' | 'exaltation' | 'detriment';

export const HD_LINE_TEXT_FIELDS: readonly HdLineTextField[] = ['description', 'exaltation', 'detriment'];

export type HdLineTextLang = 'nl' | 'en';

export const HD_LINE_TEXT_LANGS: readonly HdLineTextLang[] = ['nl', 'en'];

/** Aantal te reviewen teksten per taal: 64 poorten x 6 lijnen x 3 velden. */
export const HD_LINE_TEXTS_PER_LANG = 64 * 6 * HD_LINE_TEXT_FIELDS.length;

/** Reviewstatus van één eigen lijntekst zoals de app ze bijhoudt. */
export interface HdLineTextReview {
  readonly gate: number;
  readonly line: number;
  readonly lang: HdLineTextLang;
  readonly field: HdLineTextField;
  /** Herschreven tekst; `null` zolang de brontekst (scope-JSON) geldt. */
  readonly text: string | null;
  readonly approved: boolean;
  readonly updatedByDisplayName: string | null;
  readonly updatedOn: string;
}

export function hdLineTextReviewKey(gate: number, line: number, lang: string, field: string): string {
  return `${gate}.${line}.${lang}.${field}`;
}
